import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['parent', 'child', 'toggle']

  declare readonly parentTargets: HTMLInputElement[]
  declare readonly childTargets: HTMLElement[]
  declare readonly toggleTarget: HTMLButtonElement
  declare readonly hasToggleTarget: boolean

  connect (): void {
    this.sync()
  }

  sync (): void {
    const selected = this.parentTargets.filter(parent => parent.checked).map(parent => parent.value)
    let unchecked = false

    this.childTargets.forEach(child => {
      const visible = selected.includes(child.dataset.filterCascadeParent ?? '')

      child.classList.toggle('hidden', !visible)
      if (!visible && this.uncheck(child)) unchecked = true
    })

    if (this.hasToggleTarget) this.toggleTarget.disabled = selected.length === 0
    if (unchecked) this.dispatch('change')
  }

  private uncheck (child: HTMLElement): boolean {
    const checkbox = child.querySelector<HTMLInputElement>('input[type="checkbox"]')
    if (checkbox?.checked !== true) return false

    checkbox.checked = false
    return true
  }
}
